<template>
  <div class="course-task-result-contain clearfix">
    <section class="result-base-info clearfix">
      <div class="base-info-module clearfix">
        <span class="module-name">{{ $t('courseTask.taskName2') }}</span>
        <span class="module-value">
          <el-input
            v-model="result.taskName"
            size="small"
            :disabled="true"
          ></el-input>
        </span>
      </div>
      <div class="base-info-module clearfix">
        <span class="module-name">{{ $t('courseTask.successNum') }}</span>
        <span class="module-value">
          <el-input
            v-model="result.successNum"
            size="small"
            :disabled="true"
          ></el-input>
        </span>
      </div>
      <div class="base-info-module base-info-module2 clearfix">
        <span class="module-name">{{ $t('courseTask.taskStartEnd') }}</span>
        <span class="module-value">
          <el-date-picker
            v-model="result.time"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            size="small"
            :disabled="true"
            :range-separator="$t('datePicker.range')">
          </el-date-picker>
        </span>
      </div>
    </section>
    <section class="result-data-list">
      <el-tabs v-model="tabType" type="border-card" class="result-data-tab">
        <el-tab-pane :label="$t('courseTask.resultTab1')" name="0">
          <article class="tab-operate-line clearfix">
            <el-button type="primary" class="operate-button" @click="downLoadResult" :loading="downLoading">
              {{ $t("export") }}
            </el-button>
            <div class="operate-name">{{ $t('courseTask.coutType') }}</div>
            <div class="operate-types clearfix">
              <span :class="['operate-types-name', 
              {'operate-types-name2': index === 1, 'active': tabOneIndex === index }]"
              v-for="(item, index) in typeList" :key="'tab1'+index" @click="choseType(index)">{{ item }}</span>
            </div>
            <el-button type="primary" class="operate-button operate-button2" @click="addSupplementary"
              v-if="$hasPermission('AUTHSUPPLEMENTARY') && result.taskType === 0">
              {{ $t("courseTask.addSupplementary") }}
            </el-button>
          </article>
          <article class="tab-data-list" v-if="tabOneIndex === 0">
            <el-table v-loading="dataLoading" border class="result-table" ref="resultTable"
            :height="calHeight" :data="resultData" stripe :span-method="arraySpanMethod2">
              <el-table-column
                type="index"
                :label="$t('pop.no')"
                header-align="center"
                align="center"
                fixed
                width="55">
              </el-table-column>
              <template v-for="(item,kindex) in columnList">
                <el-table-column :prop="item.prop"
                              :key="'result'+item.prop"
                              :width="item.width"
                              header-align="center"
                              align="center"
                              class="course-task-value-link"
                              v-if="item.prop!=='courseName'"
                              :formatter="item.formatter"
                              :label="item.label"
                              :render-header="item.prop === 'setModeName' ? renderHeader : renderHeader2">
                </el-table-column>
                <el-table-column 
                              :key="'result'+item.prop"
                              :width="item.width"
                              header-align="center"
                              align="center"
                              class="course-task-value-link"
                              v-else
                              :label="item.label">
                  <template slot-scope="scope">
                    {{ scope.row.courseCalculateNum1 }}
                    <br/>
                    {{ scope.row.courseCalculateNum2 }}
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </article>
          <article class="tab-data-list" v-else>
            <el-table v-loading="dataLoading" border class="result-table" ref="resultTable"
            :height="calHeight" :data="resultData" stripe :span-method="arraySpanMethod1">
              <el-table-column
                type="index"
                :label="$t('pop.no')"
                header-align="center"
                align="center"
                fixed
                width="55">
              </el-table-column>
              <template v-for="(item,kindex) in columnList">
                <el-table-column :prop="item.prop"
                              :key="'result'+item.prop"
                              show-overflow-tooltip
                              :width="item.width"
                              header-align="center"
                              align="center"
                              :formatter="item.formatter"
                              :label="item.label">
                </el-table-column>
              </template>
            </el-table>
          </article>
        </el-tab-pane>
        <el-tab-pane :label="$t('courseTask.resultTab2')" name="1">
          <ResultDetail v-if="tabType==='1'" :taskId="taskId" :taskName="result.taskName"></ResultDetail>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label"> 
            {{ $t('courseTask.resultTab3') }}
            <el-tooltip placement="top-start" effect="light">
              <div slot="content">{{ $t("courseTask.candlarInfo") }}<br/>{{ $t("courseTask.candlarInfo2") }}</div>
              <div slot="content"></div>
              <em class="el-icon-question"></em>
            </el-tooltip>
          </span>
          <TrainerCalendar v-if="tabType==='2'" 
            :taskId="taskId"
            :taskName="result.taskName"
            :taskTime="result.time"></TrainerCalendar>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label"> 
            {{ $t('courseTask.resultTab4') }}
            <el-tooltip placement="top-start" effect="light">
              <div slot="content">{{ $t("courseTask.candlarInfo") }}<br/>{{ $t("courseTask.candlarInfo3") }}</div>
              <em class="el-icon-question"></em>
            </el-tooltip>
          </span>
          <ClassCalendar v-if="tabType==='3'"
            :taskId="taskId" 
            :taskName="result.taskName"
            :taskTime="result.time"></ClassCalendar>
        </el-tab-pane>
      </el-tabs>
    </section>
  </div>
</template>
<script>
import ResultDetail from './courseResultDetail.vue';
import TrainerCalendar from './trainerCalendar.vue';
import ClassCalendar from './classCalendar.vue';

export default {
  components: {
    ResultDetail,
    TrainerCalendar,
    ClassCalendar
  },
  data() {
    return {
      result: {
        taskName: '',
        successNum: '',
        money: '',
        taskType: null,
        time: []
      },
      tabType: '0',
      tabOneIndex: 0,
      dataLoading: false,
      typeList: [
        this.$t('courseTask.target'),
        this.$t('offering.local'), 
        this.$t('res.courseclassroomrela.teamClassification')
      ],
      taskId: '',
      resultData: [],
      spanArr1: [],
      spanArr2: [],
      spanArr3: [],
      spanArr4: [],
      spanArr5: [],
      spanArr6: [],
      columnList: this.columnList4,
      calHeight: 400,
      taskTime: [],
      downLoading: false,
      timeout: null,
      columnList1: [
        { label: this.$t('courseTask.area'), prop: 'district' },
        { label: this.$t('courseTask.areaNum'), prop: 'districtTotalNum' },
        { label: this.$t('courseTask.areaSuccess'), prop: 'districtSuccessRate'},
        { label: this.$t('courseSchedule.stieName'), prop: 'siteName' },
        { label: this.$t('courseSchedule.stieIndex'), prop: 'siteNo'},
        { label: this.$t('courseTask.startTime'), prop: 'scheduleDateStart', width: 160 },
        { label: this.$t('courseTask.endTime'), prop: 'scheduleDateEnd', width: 160 },
        { label: this.$t('courseTask.successRate'), prop: 'siteSuccessRate', width: 130},
        { label: this.$t('courseTask.successTargetNume'), prop: 'siteTotalNum' }
      ],
      columnList2: [
        { label: this.$t('courseSchedule.courseClass'), prop: 'courseKindName' },
        { label: this.$t('courseTask.classSuccessNum'), prop: 'courseSuccessNum' },
        { label: this.$t('courseTask.classSuccessRate'), prop: 'courseKindSuccessRate'},
        { label: this.$t('cert.coursename'), prop: 'courseName' },
        { label: this.$t('couse.coursecode'), prop: 'courseCode'},
        { label: this.$t('courseTask.courseSuccessNum'), prop: 'courseNum' },
        { label: this.$t('courseTask.courseSuccessRate'), prop: 'courseSuccessRate' },
        { label: this.$t('courseTask.targetArea'), prop: 'siteNo' },
        { label: this.$t('courseTask.targetAreaName'), prop: 'siteName' },
        { label: this.$t('courseTask.startTime'), prop: 'scheduleDateStart', width: 160 },
        { label: this.$t('courseTask.endTime'), prop: 'scheduleDateEnd', width: 160 },
        { label: this.$t('courseTask.successRate'), prop: 'siteSuccessRate' },
        { label: this.$t('courseTask.successTargetNume'), prop: 'siteNum' }
      ],
      columnList3: [
        { label: this.$t('courseTask.courseGroupFirst'), prop: 'courseTeamCatalogName1' },
        { label: this.$t('courseTask.classSuccessNum'), prop: 'teamCatalogSuccessCountNum' },
        { label: this.$t('courseTask.classSuccessRate'), prop: 'teamCatalogSuccessRate'},
        { label: this.$t('courseTask.courseGroupTwo'), prop: 'courseTeamCatalogName2' },
        { label: this.$t('courseTask.startTime'), prop: 'scheduleDateStart', width: 160 },
        { label: this.$t('courseTask.endTime'), prop: 'scheduleDateEnd', width: 160 },
        { label: this.$t('courseTask.successRate'), prop: 'teamCatalog2SuccessRate', width: 130},
        { label: this.$t('courseTask.successTargetNume'), prop: 'teamCatalog2SuccessCountNum' }
      ],
      columnList4: [
        { label: this.$t('courseSchedule.courseGroup'), prop: 'courseTeamCatalogNames', fixed: 'left', width: 120 },
        { label: this.$t('courseSchedule.courseType'), prop: 'courseKindName', fixed: 'left' },
        { label: this.$t('courseSchedule.courseIndex'), prop: 'courseCode', fixed: 'left', width: 150 },
        { label: this.$t('courseSchedule.courseCalculate'), prop: 'courseName', fixed: 'left', width: 140 },
        { label: this.$t('courseSchedule.weekendClass'), prop: 'weekendArrangeFlagName', fixed: 'left', width: 115 },
        { label: this.$t('courseSchedule.areaCalculate'), prop: 'districtDesc', fixed: 'left' },
        { label: this.$t('courseTask.stieName2'), prop: 'siteName', fixed: 'left' },
        { label: this.$t('courseTask.successRate'), prop: 'siteSuccessRate', fixed: 'left', width: 120 },
        { label: this.$t('courseTask.successTargetNume'), prop: 'siteSuccessDesc', fixed: 'left', width: 150 }
      ]
    };
  },
  methods: {
    renderHeader (h, {column}) {
      return h('div', [
        h('span', column.label),
          h(
            'el-tooltip',
            {
                props: {
                  effect: 'light',
                  content: this.$t('courseTask.settingModeInfo'),
                  placement: 'top',
                },
            },
            [
              h('i', {
                  class: 'el-icon-question',
                  style: 'color:#409eff;margin-left:5px;',
              }),
            ],
          ),
      ]);
    },
    renderHeader2 (h, {column}) {
      return h('div', [
        h('span', column.label)
      ]);
    },
    choseType (val) {
      this.tabOneIndex = val;
      this.formatData();
    },
    getBaseInfo () {
      this.$request.get(`/classschedule/scheduleTaskResult/queryExecuteResultInfo?scheduleTaskId=${this.taskId}`)
      .then((res) => {
        if (res) {
          this.result = {
            taskName: res.taskName,
            successNum: `${res.scheduleCourseNum  }/${  res.unScheduleCourseNum + res.scheduleCourseNum  
              }(${  (res.scheduleRate*100).toFixed(2)  }%)`,
            money: res.totalCost,
            taskType: res.taskType,
            time: [res.arrangeStartDate, res.arrangeEndDate]
          };
          this.getData();
        }
      });
    },
    getData () {
      this.dataLoading = true;
      this.$request.post('/classschedule/scheduleTaskResult/dimension', { taskId: this.taskId }).then((res) => {
        if (res) {
          this.dataLoading = false
          this.tabData1 = res.bySiteResult.map((item) => {
            return { ...item, districtTotalNum: `${item.districtSuccessCount  }/${  item.districtTotal}`,
             siteTotalNum: `${item.siteSuccessCount  }/${  item.siteTotal}` };
          });
          this.tabData2 = res.byCourseResult.map((item) => {
            return { ...item, courseSuccessNum: `${item.courseKindSuccessCount  }/${  item.courseKindTotal}`, 
            courseNum: `${item.courseSuccessCount  }/${  item.courseTotal}`,
            siteNum: `${item.siteSuccessCount  }/${  item.siteTotal}`};
          });
          this.tabData3 = res.byTeamCatalogResult.map((item) => {
            return { ...item, 
            teamCatalogSuccessCountNum: `${item.teamCatalogSuccessCount  }/${  item.teamCatalogTotal}`,
            teamCatalog2SuccessCountNum: `${item.teamCatalog2SuccessCount  }/${  item.teamCatalog2Total}` };
          });
          this.tabData4 = res.byTargetResult.map((item) => {
            const num = item.courseName.lastIndexOf('-')
            return  { ...item, courseCalculateNum1: item.courseName.substr(0, num), courseCalculateNum2: item.courseName.substr(num+1) }
          });
          this.tabOneIndex = 0;
          this.formatData();
        }
      }).catch(() => {
        this.dataLoading = false;
      });
    },
    formatData () {
      switch (this.tabOneIndex) {
        case 0:
          this.resultData = this.tabData4;
          const start = new Date(this.result.time[0]).getMonth();
          const end = new Date(this.result.time[1]).getMonth();
          let column = JSON.parse(JSON.stringify(this.columnList4));
          if (this.result.taskType === 0) {
            column.splice(6,0, {
              label: this.$t('courseSchedule.settingMode'),
              prop: 'setModeName',
              fixed: 'left',
              width: 110 });
          }
          this.columnList = this.getMonthColumnList(start, end, column);
          this.resetArraySpan();
          this.mergeData2();
          break;
        case 1:
          this.columnList = this.columnList1;
          this.resultData = this.tabData1;
          this.resetArraySpan();
          this.mergeData();
          break;
        case 2:
          this.resultData = this.tabData3;
          this.columnList = this.columnList3;
          this.resetArraySpan();
          this.mergeData3();
          break;
        default:
          break;
      }
    },
    getMonthColumnList (start, end, columnList) {
      const column = [].concat(columnList);
      const monthArr = [
        { label: '1'+this.$t('courseSchedule.month'), prop: 'janTimesDesc' },
        { label: '2'+this.$t('courseSchedule.month'), prop: 'febTimesDesc' },
        { label: '3'+this.$t('courseSchedule.month'), prop: 'marTimesDesc' },
        { label: '4'+this.$t('courseSchedule.month'), prop: 'aprTimesDesc' },
        { label: '5'+this.$t('courseSchedule.month'), prop: 'mayTimesDesc' },
        { label: '6'+this.$t('courseSchedule.month'), prop: 'junTimesDesc' },
        { label: '7'+this.$t('courseSchedule.month'), prop: 'julTimesDesc' },
        { label: '8'+this.$t('courseSchedule.month'), prop: 'augTimesDesc' },
        { label: '9'+this.$t('courseSchedule.month'), prop: 'sepTimesDesc' },
        { label: '10'+this.$t('courseSchedule.month'), prop: 'octTimesDesc' },
        { label: '11'+this.$t('courseSchedule.month'), prop: 'novTimesDesc' },
        { label: '12'+this.$t('courseSchedule.month'), prop: 'decTimesDesc' }
      ];
      for(let i=start;i <= end; i++) {
        column.push(monthArr[i]);
      }
      return column;
    },
    mergeData () {
      let index1 = 0;
      const data = this.resultData;
      for(let [k, i] of data.entries()) {
        if (k === 0) {
          this.spanArr1.push(1);
        } else {
          if (i.district === data[k-1].district) {
            this.spanArr1[index1] += 1;
            this.spanArr1.push(0);
          } else {
            this.spanArr1.push(1);
            index1 = k;
          }
        }
      }
    },
    mergeData2 () {
      let index1 = 0;
      let index2 = 0;
      let index3 = 0;
      let index4 = 0;
      let index5 = 0;
      const data = this.resultData;
      for(let [k, i] of data.entries()) {
        if (k === 0) {
          this.spanArr1.push(1);
          this.spanArr2.push(1);
          this.spanArr3.push(1);
          this.spanArr4.push(1);
          this.spanArr5.push(1);
        } else {
          if (i.courseTeamCatalogNames === data[k - 1].courseTeamCatalogNames &&
          i.courseCode === data[k-1].courseCode) {
            this.spanArr1[index1] += 1;
            this.spanArr1.push(0);
          } else {
            this.spanArr1.push(1);
            index1 = k;
          }
          if (i.courseCode === data[k-1].courseCode && i.courseKindName === data[k-1].courseKindName) {
            this.spanArr2[index2] += 1;
            this.spanArr2.push(0);
          } else {
            this.spanArr2.push(1);
            index2 = k;
          }
          if (i.courseCode === data[k-1].courseCode) {
            this.spanArr3[index3] += 1;
            this.spanArr3.push(0);
          } else {
            this.spanArr3.push(1);
            index3 = k;
          }
          if (i.courseTeamCatalogNames === data[k-1].courseTeamCatalogNames &&
          i.courseKindName === data[k-1].courseKindName && i.courseCode === data[k-1].courseCode &&
          i.courseName === data[k-1].courseName) {
            this.spanArr4[index4] += 1;
            this.spanArr4.push(0);
          } else {
            this.spanArr4.push(1);
            index4 = k;
          }
          if (i.courseTeamCatalogNames === data[k-1].courseTeamCatalogNames &&
          i.courseKindName === data[k-1].courseKindName && i.courseCode === data[k-1].courseCode &&
          i.courseName === data[k-1].courseName && i.districtDesc === data[k-1].districtDesc) {
            this.spanArr5[index5] += 1;
            this.spanArr5.push(0);
          } else {
            this.spanArr5.push(1);
            index5 = k;
          }
        }
      }
    },
    mergeData3 () {
      let index1 = 0;
      const data = this.resultData;
      for(let [k, i] of data.entries()) {
        if (k === 0) {
          this.spanArr1.push(1);
          this.spanArr2.push(1);
          this.spanArr3.push(1);
        } else {
          if (i.courseTeamCatalogName1 === data[k-1].courseTeamCatalogName1) {
            this.spanArr1[index1] += 1;
            this.spanArr2[index1] += 1;
            this.spanArr3[index1] += 1;
            this.spanArr1.push(0);
            this.spanArr2.push(0);
            this.spanArr3.push(0);
          } else {
            this.spanArr1.push(1);
            this.spanArr2.push(1);
            this.spanArr3.push(1);
            index1 = k;
          }
        }
      }
    },
    resetArraySpan () {
      this.spanArr1 = [];
      this.spanArr2 = [];
      this.spanArr3 = [];
      this.spanArr4 = [];
      this.spanArr5 = [];
    },
    arraySpanMethod1 ({ _row, _column, rowIndex, columnIndex }) {
      if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        return {
          rowspan: this.spanArr1[rowIndex],
          colspan: this.spanArr1[rowIndex] > 0 ? 1 : 0
        };
      }
    },
    arraySpanMethod2 ({ _row, _column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return {
          rowspan: this.spanArr1[rowIndex],
          colspan: this.spanArr1[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 2) {
        return {
          rowspan: this.spanArr2[rowIndex],
          colspan: this.spanArr2[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 3) {
        return {
          rowspan: this.spanArr3[rowIndex],
          colspan: this.spanArr3[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 4 || columnIndex === 5) {
        return {
          rowspan: this.spanArr4[rowIndex],
          colspan: this.spanArr4[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 6) {
        return {
          rowspan: this.spanArr5[rowIndex],
          colspan: this.spanArr5[rowIndex] > 0 ? 1 : 0
        };
      }
    },
    downLoadResult () {
      this.downLoading = true;
      const params = {
        taskId: this.taskId
      };
      this.$request.downloadByPost7(
        '/classschedule/scheduleTaskResult/export',
        `${this.result.taskName + this.$t('courseTask.resultTab1')  }.xls`,
        params, null, 'xls'
      );
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.timeout = setTimeout(() => {
        this.downLoading = false;
      }, 1500);
    },
    /**
     * @description: 创建补拍任务，根据类型跳转新建和读取页面
     * @return {*}  0 读取  1 新建
     */    
    addSupplementary () {
      this.$request.post(`/classschedule/scheduleTask/addMakeUp?scheduleTaskId=${this.taskId}`).then((res) => {
        if (res) {
          const params = { 
            taskId: res.scheduleTaskId,
            isEdit: true,
            isAdd: true
          };
          this.$router.push({
            name: res.taskType === 0 ? 'rm-courseTask-courseTaskLoad' : 'rm-courseTask-courseTaskNew',
            query: params
          });
          this.$eventHub.$emit(res.taskType === 0 ? 'courseTaskLoad' : 'courseTaskNew', params);
        }
      });
    },
  },
  watch: {
    $route() {
      if (this.$route.name === 'rm-courseTask-courseTaskResult') {
        this.taskId = this.$route.query.taskId.toString();
      }
    },
    taskId () {
      this.tabType = '0';
      this.getBaseInfo();
    }
  },
  mounted() {
    this.taskId = this.$route.query.taskId.toString();
    setTimeout(() => {
      this.calHeight = window.innerHeight - 100;
    });
    window.onresize = () => {
      setTimeout(() => {
        this.calHeight = window.innerHeight - 100;
      });
    };
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.timeout = null;
  },
};
</script>
<style lang="scss" scoped>
.course-task-result-contain {
  min-height: calc(100% - 120px);
  .result-base-info {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 12px;
    display: flex;
    .base-info-module {
      width: 31%;
      display: flex;
      line-height: 32px;
      margin-right: 3%;
      &.base-info-module2 {
        margin: 0;
      }
      .info-question {
        color: #409eff;
      }
      .module-name {
        display: block;
        margin-right: 10px;
      }
      .module-value {
        flex: 1;
      }
    }
  }
  .result-data-list {
    .tab-operate-line {
      height: 34px;
      line-height: 34px;
      margin-bottom: 20px;
      .operate-button {
        display: block;
        float: left;
        &.operate-button2 {
          float: right;
        }
      }
      .operate-name {
        float: left;
        margin: 0 10px 0 50px;
        color: #333333;
      }
      .operate-types {
        float: left;
        border: 1px solid #e9e9eb;
        color: #909399;
        border-radius: 3px;
        .operate-types-name {
          display: block;
          float: left;
          padding: 0 20px;
          cursor: pointer;
          &.operate-types-name2 {
            border-left: 1px solid #e9e9eb;
            border-right: 1px solid #e9e9eb;
          }
          &.active {
            background-color: #ecf5ff;
            color: #409eff;
          }
        }
      }
    }
    .tab-data-list {
      .result-table {
        width: 100%;
      }
    }
  }
  .course-task-value-link {
    color: #409eff;
    cursor: pointer;
    text-decoration: underline;
    word-break: break-word;
    white-space: pre-wrap;
  }
}
</style>
<style lang="scss">
.course-task-result-contain {
  .el-date-editor--daterange.el-input__inner {
    width: auto !important;
  }
  .el-range-editor--small .el-range-separator {
    line-height: 30px !important;
  }
}
</style>